import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function OrdersModule() {
  return <ModuleNavigation moduleId="OrdersModule" />;
}
